const axios = require('../libs/axios.min.js');


window.app = window.app || {};
app.request = app.request || {};

app.request = {
    get: () => {

    },
    post: (url, data) => {
        return axios.post(url, data)
            .then(response => response.data)
            .catch(error => {
                console.error('POST error:', error);
                throw error;
            });
    }
};